import { render, staticRenderFns } from "./CameraRecords.vue?vue&type=template&id=a401b5ec&scoped=true"
import script from "./CameraRecords.vue?vue&type=script&lang=js"
export * from "./CameraRecords.vue?vue&type=script&lang=js"
import style0 from "./CameraRecords.vue?vue&type=style&index=0&id=a401b5ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a401b5ec",
  null
  
)

export default component.exports